var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-blog-navigation-links"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"blog-nav-links"},_vm._l((_vm.links),function(link,idx){return _c('router-link',{key:idx,staticClass:"blog-nav-link",attrs:{"to":link.url}},[_vm._v("\n        "+_vm._s(link.name)+"\n      ")])}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }